import AjaxService from '../services/ajax-service';
import { handleServerError } from 'shared-services/error-service';
import { convertToFormData } from '../utils/helpers';

export const fetchSubteams = ({ limit, offset }) => {
    return AjaxService({
        method: 'get',
        url: `subteams`,
        params: {
            limit,
            offset
        }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const createSubteam = ({ name, logo, members }) => {
    return AjaxService({
        method: 'post',
        url: 'subteams',
        data: convertToFormData({
            name,
            logo,
            members
        })
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const fetchSubteam = subteamId => {
    return AjaxService({
        method: 'get',
        url: `subteams/${subteamId}`
    })
        .then(response => response.data)
        .catch(error => {
            handleServerError(error, {
                silent: true
            });
        });
}

export const updateSubteam = (subteamId, { name, owner, logo }) => {
    return AjaxService({
        method: 'put',
        url: `subteams/${subteamId}`,
        data: convertToFormData({
            name,
            owner,
            logo
        })
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const removeSubteam = (subteamId, removeOptions) => {
    return AjaxService({
        method: 'delete',
        url: `subteams/${subteamId}`,
        params: removeOptions
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const transferSubteam = (subteamId, member_id) => {
    return AjaxService({
        method: 'post',
        url: `subteams/${subteamId}/transfer`,
        data: { member_id }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const leaveSubteam = subteamId => {
    return AjaxService({
        method: 'post',
        url: `subteams/${subteamId}/leave`
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const addSubteamMembers = (subteamId, members_ids) => {
    return AjaxService({
        method: 'put',
        url: `subteams/${subteamId}/members`,
        data: {
            members_ids
        }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const removeSubteamMembers = (subteamId, members_ids) => {
    return AjaxService({
        method: 'delete',
        url: `subteams/${subteamId}/members`,
        data: {
            members_ids
        }
    })
        .then(response => response.data)
        .catch(handleServerError);
}
